module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_08-07e7a878b91981168979bf4de1d8c419.png";